import { z } from 'zod';
import {
    CloverCredentialResolutionOutcome,
    type CloverCredentialResolutionNormalizedResult,
    type CloverCredentialResolutionRequest,
    type CloverCredentialResolutionResponse,
} from '../../../types/ipg/clover/clover-credential-resolution.types';
import { CloverThirdPartySystemId } from '../../../types/ipg/clover/clover-system-constants';
import {
    CloverCredentialsSchema,
    CloverOAuthCredentialsPublicSchema,
    CloverOAuthCredentialsSecretSchema,
} from './clover-credential.schemas';

export const CloverCredentialResolutionRequestSchema: z.ZodType<CloverCredentialResolutionRequest> =
    z.object({
        systemId: z.literal(CloverThirdPartySystemId),
        publicCredentials: CloverOAuthCredentialsPublicSchema,
        secretCredentials: CloverOAuthCredentialsSecretSchema,
        credentialUuid: z.string().uuid().optional(),
    });

export const CloverCredentialResolutionNormalizedResultSchema: z.ZodObject<{
    credentials: typeof CloverCredentialsSchema;
    merchantId: z.ZodString;
}> = z.object({
    credentials: CloverCredentialsSchema,
    merchantId: z.string().min(1),
}) satisfies z.ZodType<CloverCredentialResolutionNormalizedResult>;

export const CloverCredentialResolutionResolvedResponseSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CloverCredentialResolutionOutcome.RESOLVED>;
    normalizedResult: typeof CloverCredentialResolutionNormalizedResultSchema;
}> = z.object({
    outcome: z.literal(CloverCredentialResolutionOutcome.RESOLVED),
    normalizedResult: CloverCredentialResolutionNormalizedResultSchema,
});

export const CloverCredentialResolutionInvalidResponseSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CloverCredentialResolutionOutcome.INVALID_CREDENTIALS>;
    message: z.ZodString;
}> = z.object({
    outcome: z.literal(CloverCredentialResolutionOutcome.INVALID_CREDENTIALS),
    message: z.string().min(1),
});

export const CloverCredentialResolutionResponseSchema: z.ZodType<CloverCredentialResolutionResponse> =
    z.discriminatedUnion('outcome', [
        CloverCredentialResolutionResolvedResponseSchema,
        CloverCredentialResolutionInvalidResponseSchema,
    ]);
